import { styled } from '@mui/material'
import PriorityHighIcon from '@mui/icons-material/PriorityHigh'

export const CustomCircleIcon = styled('div')`
  width: 64px;
  height: 64px;
  background-color: ${props =>
    props.backgroundColor === 'success'
      ? props.theme.palette.green[95]
      : props.backgroundColor === 'warning'
        ? props.theme.palette.yellow[95]
        : props.backgroundColor === 'error'
          ? props.theme.palette.red[95]
          : props.theme.palette.blue[95]};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`

export const ContainerCustomCircle = styled('div')`
  display: 'flex';
  justify-content: 'center';
  margin: ${props => props.margin};
`
export const InfoIconCustom = styled(PriorityHighIcon)`
  color: ${props => props.theme.palette.blue[50]};
  font-size: 32px;
`
